export default __webpack_public_path__ + "static/media/card-money-disabled.b4511c16.webp";